import React from "react";
import { Box } from "@mui/system";
import Divider from "@mui/material/Divider";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function ExhibitionDetails(props) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "22px 0",
        [theme.breakpoints.up("md")]: {
          flexDirection: "row",
          justifyContent: "flex-start",
        },
      }}
    >
      <Box
        sx={{
          maxWidth: "140px",
        }}
      >
        <img style={{ height: "100%", width: "100%" }} src={props.exhibition?.ExhibitionLogo} />
      </Box>
      <Divider
        orientation="vertical"
        flexItem
        sx={{
          margin: "10px 30px",
          display: "none",
          [theme.breakpoints.up("md")]: {
            display: "block",
          },
        }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          width: "100%",
          [theme.breakpoints.up("md")]: {
            width: "50%",
          },
        }}
      >
        <Typography
          variant="h5"
          sx={{
            textAlign: "center",
            color: "#3A415A",
            fontWeight: 700,
            marginBottom: "15px",
            [theme.breakpoints.up("md")]: {
              textAlign: "start",
            },
          }}
        >
          {props.exhibition?.Displayed_Name}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            textAlign: "center",
            color: "#3A415A",
            fontWeight: 400,
            marginBottom: 0,
            [theme.breakpoints.up("md")]: {
              textAlign: "start",
              marginBottom: "15px",
            },
          }}
        >
          {props.exhibition?.TimePeriod}
        </Typography>
        <Divider
          orientation="horizontal"
          flexItem
          sx={{
            margin: "10px 30px",
            display: "block",
            [theme.breakpoints.up("md")]: {
              display: "none",
            },
          }}
        />
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            color: "#3A415A",
            [theme.breakpoints.up("md")]: {
              textAlign: "start",
            },
          }}
        >
          {props.exhibition?.Description}
        </Typography>
      </Box>
    </Box>
  );
}
